import { Component, OnInit } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { PopUpService } from '../PopUpService';
import { SharedService } from '../shared.service';
import { Router } from '@angular/router';
import { GenOTPRequest } from '../registeration/gen-otp-request';
import { OTPResponse } from '../registeration/gen-otp-response';
import { LoaderService } from '../../loader/loader.service';
import { InfoService } from '../../info/info-service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { DataStorageService } from '../data-storage.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  image: string;
  constructor(private router: Router,
    private logger: NGXLogger,
    private popUpService: PopUpService,
    private sharedService: SharedService,
    private infoService: InfoService,
    private dataStorageService: DataStorageService,
    private loaderService: LoaderService,

    private translate: TranslateService) { }

  username: string = "";
  // ekpayUser:EkpayUser;
  getotpReq: GenOTPRequest;
  otpResponse: OTPResponse;
  subscription: Subscription;
  lang: string;
  isCaptchaValid: boolean = false;
  captcha: string = "";
  ngOnInit() {
    this.subscription = this.dataStorageService.langData$.subscribe((data) => {
      this.lang = data;
      if (this.lang == '' || this.lang == null) {
        this.lang = localStorage.getItem("lang");
      }
      this.logger.debug('data lang is ' + this.lang);
      this.translate.use(this.lang);
    })
    this.sharedService.getCapcha().subscribe(data => {
      this.logger.debug("response...." + data);
      this.image = data;
    });
  }
  refreshCaptcha() {
    this.image = null;
    this.sharedService.getCapcha().subscribe(data => {
      this.logger.debug("response...." + data);
      this.image = data;
    });
  }



  getUser() {
    window.scroll(0, 0);
    this.logger.debug("calling get user method....." + this.username);
    this.isCaptchaValid=false;
    this.loaderService.show();
    this.sharedService.validateCapcha(this.captcha).subscribe(data => {
      this.logger.debug("response...." + JSON.stringify(data));
      if (data == "success") {
        this.sharedService.getUser(this.username).subscribe(data => {
          this.logger.debug("response...." + JSON.stringify(data.body));
          if (data.body.status) {
            this.getotpReq = new GenOTPRequest;
            // this.ekpayUser = this.ekpayUserResponse.ekpay_user;
            // this.getotpReq.ekpayId = this.ekpayUser.ekpay_id;
            // this.getotpReq.email = this.ekpayUser.email_id;
            //this.getotpReq.mobile = data.body.mobile;
            this.getotpReq.mobile = "";
            this.getotpReq.module = "forgot password";
            sessionStorage.setItem("getotpReq", JSON.stringify(this.getotpReq));
            this.sharedService.getOTP(this.getotpReq).subscribe((inndata) => {
              this.loaderService.hide();
              this.logger.debug("calling get otp method...." + JSON.stringify(inndata));
              this.otpResponse = inndata.body as OTPResponse;
              if ("success" == this.otpResponse.status) {
                sessionStorage.setItem("otp_id", this.otpResponse.otp.otp_id);
                sessionStorage.setItem("otp_response", JSON.stringify(data.body));
                sessionStorage.setItem("otpType", "forgotpassword");
                this.popUpService.isOtp = true;
                this.popUpService.isForgot = false;
              }
            });
          } else {
            this.loaderService.hide();
            this.popUpService.isForgot = false;
            this.infoService.header = "Info";
            this.infoService.message = "User not found."
            this.router.navigate(['info']);
          }
        });
      } else {
        this.loaderService.hide();
        this.isCaptchaValid = true;
      }
    });

  }

  closePop() {
    this.popUpService.isForgot = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/forgot-password/forgot-password.component.ts